var _styled;

// https://govuk-elements.herokuapp.com/errors/
// https://govuk-elements.herokuapp.com/errors/example-form-validation-single-question-radio
// This is to be used when more than one value of a radio/checkbox group requires validation.
// e.g. What is your gender?
// () Male
// () Female
// () Other
// Only one is valid, but at least one must be selected.
// Therefore validation around the set of radios is required.
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { ERROR_COLOUR } from 'govuk-colours';
import LabelText from '@govuk-react/label-text';
import ErrorText from '@govuk-react/error-text';
import HintText from '@govuk-react/hint-text';
import { BORDER_WIDTH_MOBILE, MEDIA_QUERIES, SITE_WIDTH, SPACING } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledFieldset = styled('div')((_styled = {
  padding: 0,
  margin: 0,
  border: 0,
  boxSizing: 'border-box',
  width: '100%',
  ':after': {
    content: "''",
    display: 'table',
    clear: 'both'
  }
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  maxWidth: SITE_WIDTH
}, _styled), function (_ref) {
  var error = _ref.error;
  return {
    borderLeft: error ? BORDER_WIDTH_MOBILE + " solid " + ERROR_COLOUR : undefined,
    marginRight: error ? SPACING.SCALE_3 : undefined,
    paddingLeft: error ? SPACING.SCALE_2 : undefined
  };
});

var MultiChoice = function MultiChoice(_ref2) {
  var meta = _ref2.meta,
      label = _ref2.label,
      children = _ref2.children,
      hint = _ref2.hint,
      className = _ref2.className;
  return React.createElement(StyledFieldset, {
    className: className,
    error: meta.touched && meta.error
  }, React.createElement(LabelText, null, label), hint && React.createElement(HintText, null, hint), meta.touched && meta.error && React.createElement(ErrorText, null, meta.error), children);
};

MultiChoice.defaultProps = {
  hint: undefined,
  className: undefined,
  meta: {}
};
MultiChoice.propTypes = process.env.NODE_ENV !== "production" ? {
  meta: PropTypes.shape({
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    dirtySinceLastSubmit: PropTypes.bool,
    error: PropTypes.any,
    initial: PropTypes.bool,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitError: PropTypes.any,
    submitFailed: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool
  }),
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  hint: PropTypes.string,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(MultiChoice);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/multi-choice/es/index.js
// module id = 86
// module chunks = 0